// extracted by mini-css-extract-plugin
export default {"editModal":"styles_editModal__iznmW","textarea":"styles_textarea__yn58P"};